import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button, DataGridCustom } from '../../components';
import Masks from '../../utils/masks';
import { operacoesStatusGet } from '../../utils/listsSelect';
import {
  doGet,
} from '../../utils/requests';

class FiltroPesquisaOperacoesGet extends Component {
  constructor() {
    super();
    this.filtroPesquisaOperacoesGet = JSON.parse(sessionStorage.getItem('filtroPesquisaOperacoesGet'));
    this.state = {
      cpf:
        this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.cpf ?
          this.filtroPesquisaOperacoesGet.cpf : null,
      protocoloComprev:
        this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.protocoloComprev ?
          this.filtroPesquisaOperacoesGet.bodyEnvio : null,
      protocoloTarefaGet:
          this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.protocoloTarefaGet ?
            this.filtroPesquisaOperacoesGet.protocoloTarefaGet : null,
      mensagem:
          this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.mensagem ?
            this.filtroPesquisaOperacoesGet.mensagem : null,
      nivelUo:
          this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.nivelUo ?
            this.filtroPesquisaOperacoesGet.nivelUo : null,
      idUo:
          this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.idUo ?
            this.filtroPesquisaOperacoesGet.idUo : null,
      status:
          this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.status ?
            this.filtroPesquisaOperacoesGet.status : null,
      superintendencia:
          this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.superintendencia ?
            this.filtroPesquisaOperacoesGet.superintendencia : null,
      gex:
          this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.gex ?
            this.filtroPesquisaOperacoesGet.gex : null,
      aps:
          this.filtroPesquisaOperacoesGet && this.filtroPesquisaOperacoesGet.aps ?
            this.filtroPesquisaOperacoesGet.aps : null,
      listaSuperintendencias: [],
      listaGexs: [],
      listaAps: [],
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem('filtroPesquisaOperacoesGet')) {
      this.handleSearchButton();
    }
    this.carregaUnidadesOrganicas(24, null, this.carregaSuperintendencias);
  }
  carregaUnidadesOrganicas = (categoria, codigoSuperior, sucesso) => {
    const parametros = {};
    if (codigoSuperior) {
      parametros.codigoSuperior = codigoSuperior;
    }
    if (categoria) {
      parametros.categoria = categoria;
    }
    doGet('unidades-organicas', sucesso, this.tratarErro, parametros);
  }

  carregaSuperintendencias = (response) => {
    const superintendencias = [];
    response.data.forEach((item) => {
      superintendencias.push({
      //    label: item.nomeUnidade,
        label: item.codigoUnidade.concat(' - ', item.nomeUnidade),
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaSuperintendencias: superintendencias });
  }

  carregaGexs = (response) => {
    const gexs = [];
    response.data.forEach((item) => {
      gexs.push({
        label: item.codigoUnidade.concat(' - ', item.nomeUnidade),
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaGexs: gexs });
  }

  carregaAps = (response) => {
    const aps = [];
    response.data.forEach((item) => {
      aps.push({
        label: item.codigoUnidade.concat(' - ', item.nomeUnidade),
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaAps: aps });
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    }, () => this.trataFormulario(name));
  }

  handleKeyDown = (e) => {
    let retorno = null;
    if (e.keyCode === 13) {
      retorno = this.handleSeParchButton();
    }
    return retorno;
  }

  handleChangeMascaraFiltro = (changeObj, name) => {
    let mascaraAtual = '';
    switch (changeObj.value) {
      case 1:
        mascaraAtual = 'cpf';
        break;
      default:
        mascaraAtual = 'cpf';
        break;
    }
    this.setState({
      [name]: changeObj.value,
      mascara: mascaraAtual,
    }, () => this.trataFormulario(name));
  }

  trataFormulario = (campoAlterado) => {
    if (campoAlterado === 'superintendencia') {
      this.setState({ gex: null, aps: null, ente: null });
      if (this.state.superintendencia) {
        this.carregaUnidadesOrganicas(3, this.state.superintendencia, this.carregaGexs);
      }
    }
    if (campoAlterado === 'gex') {
      this.setState({ aps: null, ente: null });
      if (this.state.gex) {
        this.carregaUnidadesOrganicas(4, this.state.gex, this.carregaAps);
      }
    }
  }

  addMessage = (text) => {
    const message = {
      title: 'Titulo',
      text,
      timeout: 5000,
      type: 'danger',
    };
    window.DtpSnackbar.addMessage(message);
  };

  handleSearchButton = () => {
    let filtroPesquisaOperacoesGet = {
      cpf: this.state.cpf,
      cliqueiNoBotao: this.state.cliqueiNoBotao,
      //     filtro: this.state.filtro,
      mascara: this.state.mascara,
      protocoloComprev: this.state.protocoloComprev,
      mensagem: this.state.mensagem,
      protocoloTarefaGet: this.state.protocoloTarefaGet,
      status: this.state.status,
    };
    filtroPesquisaOperacoesGet = JSON.stringify(filtroPesquisaOperacoesGet);
    sessionStorage.setItem('filtroPesquisaOperacoesGet', filtroPesquisaOperacoesGet);

    this.handleSearchOperacoesGet();
  }

  handleSearchOperacoesGet = () => {
    const superintendenciaSelecionada = this.state.superintendencia;
    const statusSelecionado = this.state.status;
    const protocoloPreenchido = this.state.protocoloComprev;
    const protocoloTarefaGetPrenchido = this.state.protocoloTarefaGet;
    const cpfPreenchido = this.state.cpf;
    let valido = false;

    if (protocoloTarefaGetPrenchido || protocoloPreenchido || cpfPreenchido) {
      valido = true;
    }

    if (!valido && superintendenciaSelecionada && statusSelecionado) {
      valido = true;
    }

    if (valido) {
      this.props.handleSearchFilter(this.state);
    } else {
      this.addMessage('É obrigatório o preenchimento de [CPF ou protocolo ou protocolo tarefa GET] e/ou [Alguma Unidade Orgânica e Status da Operação]');
    }
  }
  montaFiltrosOperacoesGet = () => (
    <React.Fragment>
      <DataGridCustom title="UO de Criação da Tarefa GET">
        <div className="row">
          <Grid cols="8 8 8 8">
            <Input
              label="Superintendência"
              onChange={e => this.handleChange(e, 'superintendencia')}
              placeholder="Todas"
              value={this.state.superintendencia}
              itemList={this.state.listaSuperintendencias}
              custom
            />
          </Grid>
          {this.state.superintendencia ? (
            <Grid cols="8 8 8 8">
              <Input
                label="GEX"
                onChange={e => this.handleChange(e, 'gex')}
                placeholder="Todas"
                value={this.state.gex}
                itemList={this.state.listaGexs}
                custom
              />
            </Grid>
          ) : ''}
          {this.state.gex ? (
            <Grid cols="8 8 8 8">
              <Input
                label="APS"
                onChange={e => this.handleChange(e, 'aps')}
                placeholder="Todas"
                value={this.state.aps}
                itemList={this.state.listaAps}
                custom
              />
            </Grid>
        ) : ''}
        </div>
      </DataGridCustom>
      <DataGridCustom title="Informações das Operações GET" >
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              label="Protocolo Comprev"
              onChange={e => this.handleChange(e, 'protocoloComprev')}
              value={this.state.protocoloComprev}
              validationState="active"
              consultaOperacoesGet
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              label="Protocolo Tarefa GET"
              onChange={e => this.handleChange(e, 'protocoloTarefaGet')}
              value={this.state.protocoloTarefaGet}
              validationState="active"
              consultaOperacoesGet
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              cpf
              integer
              label="CPF"
              mask={Masks.cpf}
              onChange={e => this.handleChange(e, 'cpf')}
              onKeyDown={e => this.handleKeyDown(e, 'cpf')}
              showMask
              value={this.state.cpf}
              validationState="active"
            />
          </Grid>
          <Grid cols="4 4 4 4">
            <Input
              label="Status Operação"
              name="status"
              itemList={operacoesStatusGet}
              onChange={e => this.handleChange(e, 'status')}
              value={this.state.status}
              validationState="active"
              custom
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              label="Mensagem Retorno"
              onChange={e => this.handleChange(e, 'mensagem')}
              value={this.state.mensagem}
              validationState="active"
              consultaOperacoesGet
            />
          </Grid>
        </div>
      </DataGridCustom>
    </React.Fragment>
  )
  render() {
    const filtrosPesquisa = this.montaFiltrosOperacoesGet();
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="pesquisa"
          panelId="filtro-pesquisa"
          icon="ico-filter"
          title="Filtro de Pesquisa"
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearchButton()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}
FiltroPesquisaOperacoesGet.propTypes = {
  handleChangeList: PropTypes.func,
  handleSearchFilter: PropTypes.func,
  list: PropTypes.array,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default FiltroPesquisaOperacoesGet;



// WEBPACK FOOTER //
// ./src/pages/consultas/FiltroPesquisaOperacoesGet.jsx